import { createSlice } from '@reduxjs/toolkit';

const dashboardActiveComponentSlice = createSlice({
    name: 'dashboardActiveComponent',
    initialState: {
      activeComponent: 'feeds',
    },
    reducers: {
      setDashboardActiveComponent: (state, action) => {
        state.activeComponent = action.payload;
      },
      clearDashboardActiveComponent: (state) => {
        state.activeComponent = null;
      }
    },
  });
  
  export const { setDashboardActiveComponent, clearDashboardActiveComponent } = dashboardActiveComponentSlice.actions;
  export default dashboardActiveComponentSlice.reducer;